import React from 'react'
import { Button, Input } from '../../../../components/Generic'
import { ellips, phone } from '../../../../assets'

const NumVer = () => {
  return (
    <>
            <img className="absolute top-[40%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
    <div className='flex flex-col mt-[100px] justify-center items-center z-10'>
      <img className='' src={phone} alt="" />
      <div className='text-gray-darkGray font-sans text-[20px] mt-[24px]'>Verifacation</div>
      <div className='text-gray-lightGray font-sans mt-[0px] text-[16px] '>Verificate with phone number</div>
      <div className='custom-styles mt-[102px] flex justify-center'>
      <Input style={`h-[60px] px-[15px] md:w-[388px]`} corner={true} placeholder={'+998 | Enter Number'}/>
      </div>
      <div className='w-[288px] mt-[157px] md:w-full flex justify-center mb-[100px]'>
      <Button link='/vercode' style={`w-[388px]`} value={'Next'}/>
      </div>
    </div>
    </>
  )
}

export default NumVer